import { useState } from 'react';

import { Box, Popover, Typography, useTheme } from '@material-ui/core';
import { RiEyeLine } from 'react-icons/ri';

import { MAIN_CONTAINER_ID } from '@vyce/core/src/constants';

export const FormResultResponses = ({ count, names }: { count: number; names: string[] }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box>
      <Box
        onClick={handleClick}
        padding={1}
        paddingLeft={2}
        display="flex"
        alignItems="center"
        gridGap={8}
        borderRadius={12}
        style={{ backgroundColor: theme.palette.background.default }}
      >
        <Typography variant="body1" color="textSecondary">
          {`${count} ${count === 1 ? 'response' : 'responses'}`}
        </Typography>

        {names?.length > 0 && <RiEyeLine size={18} color={theme.palette.text.secondary} />}
      </Box>

      {names?.length > 0 && (
        <Popover
          id={id}
          container={document.getElementById(MAIN_CONTAINER_ID)}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          elevation={0}
          style={{ marginTop: '4px' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <Box
            padding={1}
            paddingLeft={2}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gridGap={8}
          >
            {names.map(name => (
              <Box key={name} padding={1} paddingLeft={2} display="flex" alignItems="center" gridGap={8}>
                <Typography variant="body1" color="textSecondary">
                  {name}
                </Typography>
              </Box>
            ))}
          </Box>
        </Popover>
      )}
    </Box>
  );
};
